import React, { useEffect, useRef, useState } from 'react';

import { motion } from 'framer-motion';
import Roadmap from './Roadmap'; // Asegúrate de tener la ruta correcta al archivo Roadmap
import EduSolDetails from './EduSolDetails'; // Importa el nuevo componente
import CoursesSection from './CoursesSection'; // Importa el nuevo componente

function HomePage() {


  return (
    <div className="relative min-h-screen text-white animated-gradient">
      {/* Estilos para la página */}
      <style>
        {`
          @keyframes gradientBackground {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .animated-gradient {
            background: linear-gradient(270deg, #000637, #5f01bd, #000637);
            background-size: 800% 800%;
            animation: gradientBackground 15s ease infinite;
          }
          .glow-effect {
            text-shadow: 0 0 8px #5d39fe, 0 0 10px #5d39fe, 0 0 14px #5d39fe, 0 0 14px #5d39fe;
          }
          .glow-button {
            background-color: #5d39fe;
            color: white;
            border: none;
            padding: 8px 16px;
            font-size: 1rem;
            border-radius: 4px;
            cursor: pointer;
            position: relative;
            text-decoration: none;
            transition: transform 200ms, box-shadow 200ms;
            text-shadow: 0 0 10px #5d39fe, 0 0 20px #5d39fe, 0 0 30px #5d39fe;
          }
          .glow-button:hover {
            transform: scale(1.05);
            box-shadow: 0 0 10px #5d39fe, 0 0 20px #5d39fe, 0 0 30px #5d39fe, 0 0 40px #5d39fe;
          }
        `}
      </style>

{/* Navbar */}
<nav className="fixed top-0 w-full p-4 flex justify-between items-center z-20" style={{ backgroundColor: '#000637' }}>
  <div className="flex items-center">
    <img src="/edusol.png" alt="EduSol Logo" className="h-12" />
    <h1 className="text-4xl font-bold text-white ml-4"><span className="glow-effect">EduSol</span></h1>
  </div>
  <div>
  {/* <a
  href="https://www.pump.fun/FrLADkDCve33cTps7FqRF6vayMejXV7iTpZWZzuywi15"
  data-aos="flip-up"
  data-aos-offset="300"
  data-aos-duration="1000"
  className="glow-button mr-4 inline-block text-center"
  style={{ padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', color: 'white' }}
>
  Buy $EduSol
</a> */}

  <a
  href="/EduSol.pdf"
  download="EduSol-Whitepaper.pdf"
  data-aos="flip-up"
  data-aos-offset="300"
  data-aos-duration="1000"
  className="glow-button mr-4 inline-block text-center"
  style={{ padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', color: 'white' }}
>
  Whitepaper
</a>

<a
  href="https://twitter.com/EduSolanaOfi"
  data-aos="flip-up"
  data-aos-offset="300"
  data-aos-duration="1000"
  className="glow-button mr-4 inline-block text-center"
  style={{ padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', color: 'white' }}
>
  Twitter
</a>
  </div>
</nav>

      {/* Main content */}
      <div className="relative z-10 p-8">
        <div className="flex flex-col lg:flex-row items-center justify-center pt-32 my-20 lg:pt-24">
          {/* Welcome section */}
          <motion.div
              initial={{ opacity: 0, scale: 0.7 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
              className="bg-white/10 backdrop-blur-md p-8 rounded-lg shadow-lg text-center max-w-md m-4"
            >
              <h1 className="text-4xl font-bold">Welcome to <span className="glow-effect">EduSol</span></h1>
              <p>Education through Solana's Blockchain</p>
          </motion.div>
          
          {/* EduSol Logo */}
          <motion.div
              initial={{ opacity: 0, scale: 0.7 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            >
              <img src="/edusol.png" alt="EduSol Logo" className="rounded-full h-60 lg:h-[40rem] transition-shadow duration-500" />
          </motion.div>
        </div>

        {/* EduSol Details Section */}
        <EduSolDetails />
        {/* Courses Section */}
        <CoursesSection />
        {/* Roadmap Section */}
        <Roadmap />

        {/* Gallery Section */}
        {/* <section className="gallery">
          <h2 className="text-3xl font-bold my-5">Our Community</h2>
        </section> */}

        {/* Footer or additional sections */}
      </div>
    </div>
  );
}

export default HomePage;
